export const assistancesYue = [
  { id: '1', value: '没有' },
  { id: '13', value: '沒有，但我需要一些幫助（上門服務)' },
  { id: '4', value: '輪椅（不能折疊)' },
  { id: '15', value: '輪椅（可以折疊)' },
  { id: '3', value: '助行架' },
  { id: '6', value: '我需要輪床 / 擔架床' },
];
